import $store from '../store'
import axios from 'axios'

/**
 * Current user state initialization
 * @WARN Must be always first in middleware chain
 */
export async function initCurrentUserStateMiddleware (to, from, next) {
  next()
}

/**
 * Check access permission to auth routes
 */
export function checkAccessMiddleware (to, from, next) {
  const isAuthRoute = to.matched.some(item => item.meta.isAuth)
  const requireLogin = to.meta.requireLogin
  const currentUser = localStorage.getItem('currentUser')
  const token = localStorage.getItem('token')
  if (requireLogin && !currentUser) {
    return next({ name: 'login' })
  }
  axios.defaults.headers.common.Authorization = `Bearer ${token}`
  if (requireLogin && currentUser) {
    const user = JSON.parse(currentUser)
    if (Date.now() >= user.exp * 1000) {
      localStorage.clear()
      return next({ name: 'login' })
    }
    return next()
  }
  if (isAuthRoute && token && currentUser) {
    $store.commit('user/SET_CURRENT_USER', JSON.parse(currentUser))
    return next()
  }
  if (isAuthRoute) return next({ name: 'login' })
  next()
}

export function setPageTitleMiddleware (to, from, next) {
  const pageTitle = to.matched.find(item => item.meta.title)

  if (pageTitle) window.document.title = pageTitle.meta.title
  next()
}
